import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Icon from '../../../components/icon/Icon';

export interface SideBarSubMenuProps {
  label?: string;
  labelWithoutTranslation?: string;
  icon?: string;
  badge?: number | string | null;
  onClose?: (() => void) | null;
  children: ReactNode;
}

const SideBarSubMenu: React.FC<SideBarSubMenuProps> = ({
  icon,
  label,
  labelWithoutTranslation,
  onClose,
  badge,
  children,
}) => {
  const intl = useIntl();

  const getTitle = () => {
    if (labelWithoutTranslation) return labelWithoutTranslation;
    if (label && intl.messages[label]) return intl.formatMessage({ id: label });
    return label || '';
  };

  return (
    <div className="navigation--sub-menu">
      {(label || labelWithoutTranslation) && (
        <div className="navigation--sub-menu-header">
          <div className="notification-badge--wrapper">
            {badge && Number(badge) > 0 && (
              <span className="notification-badge">{badge}</span>
            )}
            {icon && <Icon icon={icon} />}
          </div>

          <div className="navigation--sub-menu-header-title">{getTitle()}</div>

          {onClose && (
            <div
              className="navigation--sub-menu-header-close"
              onClick={onClose}
            >
              <Icon icon="close" />
            </div>
          )}
        </div>
      )}

      <div className="navigation--sub-menu-content">
        <Scrollbars style={{ height: '100%' }}>{children}</Scrollbars>
      </div>
    </div>
  );
};

export default SideBarSubMenu;
